import { ApplicationConfig, DEFAULT_CURRENCY_CODE, ErrorHandler, LOCALE_ID, importProvidersFrom } from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';
import { routes } from './app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptorsFromDi, withInterceptors } from '@angular/common/http';
import { provideToastr } from 'ngx-toastr';
import { NgxSpinnerModule } from 'ngx-spinner';
import { CommonModule, CurrencyPipe, DATE_PIPE_DEFAULT_OPTIONS, DatePipe, HashLocationStrategy, JsonPipe, LocationStrategy, registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { provideEnvironmentNgxMask, NgxMaskConfig } from "ngx-mask";
import { autenticacaoInterceptor } from './autenticacao.interceptor';
import { MatTableModule } from '@angular/material/table';

registerLocaleData(localePt);

const maskConfig: Partial<NgxMaskConfig> = {
  validation: true,
  allowNegativeNumbers: true,
  decimalMarker: ",",
  clearIfNotMatch: false,
  dropSpecialCharacters: true,
  thousandSeparator: "."
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withHashLocation()),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi(), withInterceptors([autenticacaoInterceptor])),
    provideToastr({
      autoDismiss: true,
      closeButton: true,
      timeOut: 5000,
      enableHtml: true,
    }),
    importProvidersFrom(NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' })),
    importProvidersFrom(MatTableModule),
    {
      provide: LOCALE_ID,
      useValue: 'pt-BR'
    },
    JsonPipe,
    DatePipe,
    CurrencyPipe,
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
    {
      provide: DEFAULT_CURRENCY_CODE,
      useValue: 'BRL',
    },
    {
      provide: DATE_PIPE_DEFAULT_OPTIONS,
      useValue: {
        dateFormat: "dd/MM/yyyy",
      },
    },
    provideEnvironmentNgxMask(maskConfig),
  ]
};
